/**
 * Columnas de las tablas de reservas (densidad desktop), en un solo lugar.
 *
 * Las usan TRES módulos que antes tenían cada uno su copia: la tabla del día
 * (`ReservationGroup`), la lista plana de archivadas (`ReservationsView`) y la
 * fila (`ReservationRow`), que necesita el CONTEO para el `colspan` de la fila
 * de comentarios. Con copias sueltas, agregar una columna dejaba el comentario
 * ocupando menos de lo que debía sin que nada avisara.
 *
 * Los anchos (en %) alimentan un `<colgroup>` con layout `table-fixed`: la tabla
 * nunca excede su contenedor, así que no hay scroll horizontal (regla dura del
 * rediseño full-width). El contenido largo se recorta con `truncate` en la celda.
 * Por eso mismo NO conviene sumar columnas acá: ya suman 100%.
 */
export const RESERVATION_COLUMNS = [
    { label: 'Hora', width: 9 },
    { label: 'Nombre', width: 21 },
    { label: 'Personas', width: 8 },
    { label: 'Área', width: 11 },
    { label: 'Momento', width: 10 },
    { label: 'Estado', width: 25 },
    { label: 'Acciones', width: 16 },
];

/** Cuántas columnas ocupa una fila a lo ancho (`colspan` del comentario). */
export const RESERVATION_COLSPAN = RESERVATION_COLUMNS.length;

/** Clase de los `<th>`, compartida por las dos tablas. */
export const RESERVATION_TH =
    'px-3 py-3 text-[10px] font-black uppercase tracking-widest text-text-muted truncate';
